// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1rgDh","type":"styles_type__1ElhT","choices":"styles_choices__2PbBK"};